import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItems } from 'src/app/shared/menu-items/menu-items';

/**
 * Thin app-specific wrapper around the shared, reusable
 * app-sidebar-nav (src/app/ReusableComponents/sidebar-nav) — it only wires
 * MenuItems (rights-gated nav data, unchanged) into the generic rail, and
 * forwards the collapse toggle up to LayoutComponent, which owns the
 * mat-drawer width.
 */
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    standalone: false
})
export class SidebarComponent implements OnInit {

  /** True = narrow icon-only rail. */
  @Input() collapsed = false;
  @Output() collapsedChange = new EventEmitter<boolean>();

  constructor(public menuItems: MenuItems) { }

  ngOnInit(): void {
    this.menuItems.setAccessLinks();
  }
}
